import { handle } from 'redux-pack';
import { GET_EVENTS } from './types';
import { SEARCH } from '../search/types';

const initialState = {
  data: [],
  updateCount: 0,
};

export const geojsonReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENTS:
    case SEARCH:
      return handle(state, action, {
        success: prevState => ({
          ...prevState,
          data: payload,
          updateCount: state.updateCount + 1,
        }),
      });
    default:
      return state;
  }
};
